import { render, staticRenderFns } from "./CreateRoleDlg.vue?vue&type=template&id=7e8cfc72&"
import script from "./CreateRoleDlg.vue?vue&type=script&lang=js&"
export * from "./CreateRoleDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports